// extracted by mini-css-extract-plugin
module.exports = {"separator":"EditClassForm_separator__3UGDf"};